import { HomeType } from '@app/entities/enums/user/user.enum';
import { UserCookies } from '@app/shared/models/cookies/cookies.config';

import { Conditions } from './conditions.model';
import { Company } from '../ptrab/shared/company.model';

export class User extends Conditions {
  alias!: string;
  cookies!: UserCookies;
  cod_department!: string;
  department!: string;
  division_zone!: string;
  email!: string;
  external!: boolean;
  language_code!: string;
  language_country!: string;
  language_name!: string;
  lastname!: string;
  login!: string;
  name!: string;
  photo!: string;
  cod_store!: string;
  store!: string;
  userid!: string;
  zone!: string;
  isDiscontinousFixed?: boolean;
  companies!: Company[];
  home_type!: HomeType;
  walkthroughs!: string[];

  constructor() {
    super();
  }
}

export class RepresentedUser {
  cod_store!: string | null;
  department!: string;
  division_zone!: string;
  lastname!: string;
  name!: string;
  photo!: string;
  store!: string;
  userid!: string;
}
